import Vue from 'vue'
import { toLocaleDate } from 'services/i18n/dates'
import { money } from 'services/i18n/currencies'
import { round, percentage } from 'services/i18n/numbers'

export const bootstrap = async () => {
  Vue.filter('date', toLocaleDate)
  Vue.filter('round', round)
  Vue.filter('money', money)
  Vue.filter('percentage', percentage)
  Vue.filter('mapJoin', _.mapJoin)
}
